"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaffCoverOptionsMessage = void 0;
var _react = _interopRequireWildcard(require("react"));
var _stringHelpers = require("@PetSureAustralia/petsure-react-ui-library/distLib/helpers/stringHelpers");
var _tableContext = require("../productsTable/stateHelpers/tableContext");
var _productHelpers = require("../../helpers/productHelpers");
var _staffModeHelpers = require("./staffModeHelpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var StaffCoverOptionsMessage = exports.StaffCoverOptionsMessage = function StaffCoverOptionsMessage() {
  var _useContext = (0, _react.useContext)(_tableContext.TableContext),
    _useContext$tableCont = _useContext.tableContext,
    brand = _useContext$tableCont.brand,
    staffInstructions = _useContext$tableCont.staffInstructions,
    AddOnsMap = _useContext$tableCont.AddOnsMap,
    AllPlans = _useContext$tableCont.AllPlans,
    _useContext$tableStat = _useContext.tableState,
    productsAreMerged = _useContext$tableStat.productsAreMerged,
    visiblePlans = _useContext$tableStat.visiblePlans;
  if (staffInstructions.levelsOfCover) {
    return staffInstructions.levelsOfCover();
  }
  var levelsOfCover = _toConsumableArray(new Set(Object.values(visiblePlans).reduce(function (acc, visiblePlan) {
    var planNumber = visiblePlan.planNumber;
    var _GetAllLevelsOfCover = (0, _productHelpers.GetAllLevelsOfCover)({
        planNumber: planNumber,
        productDefinition: visiblePlan,
        AddOnsMap: AddOnsMap,
        AllPlans: AllPlans
      }),
      levelsOfCover = _GetAllLevelsOfCover.levelsOfCover,
      stepDownLevelsOfCover = _GetAllLevelsOfCover.stepDownLevelsOfCover;
    if (productsAreMerged) {
      return acc.concat(levelsOfCover);
    }
    return acc.concat(visiblePlan.levelsOfCover);
  }, [])));
  if (levelsOfCover.length === 1) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "staffScriptItem"
    }, (0, _stringHelpers.Capitalize)(brand), " Pet Insurance offers a range of cover options which all provide up to ", levelsOfCover[0], "% back on eligible vet bills.");
  }
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: "staffScriptItem"
  }, (0, _stringHelpers.Capitalize)(brand), " Pet Insurance offers a range of cover options which provide up to  ", levelsOfCover.map(function (levelOfCover, index) {
    return "".concat(levelOfCover, "%").concat((0, _staffModeHelpers.GetSeparator)({
      fullNumber: levelsOfCover.length,
      index: index,
      joiningWord: 'or ',
      midSentence: true
    }));
  }), " back on eligible vet bills.");
};